import {
  Badge,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Field,
  FieldTitle,
  Separator,
} from "@beweegbaas/ui";
import { createFileRoute } from "@tanstack/react-router";
import { Fragment } from "react";
import { getStudentSportParticipation } from "#/modules/school.students/students.functions";
import {
  SportdeelnameFieldCell,
  SportdeelnameFieldEditor,
  sportdeelnameFieldLabels,
  sportdeelnameFieldTitle,
  type SportdeelnameField,
} from "#/modules/sportdeelname/components/sportdeelname-field-cells";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/students/$id/sport-participation",
)({
  loader: ({ params }) => getStudentSportParticipation({ data: { leerlingId: params.id } }),
  component: StudentSportParticipationPage,
});

const FIELDS: SportdeelnameField[] = [
  "sporten",
  "verenigingen",
  "wenssporten",
  "mrt",
  "zwemvaardigheid",
  "fietsvaardigheid",
];

/** Small fixed option sets render as inline checkbox groups; the sport lists open a popover. */
const INLINE_FIELDS: SportdeelnameField[] = ["mrt", "zwemvaardigheid", "fietsvaardigheid"];

function StudentSportParticipationPage() {
  const { data } = Route.useLoaderData();

  return (
    <div className="flex flex-col gap-6">
      <Card>
        <CardHeader className="border-b pb-6">
          <CardTitle>{m["sportdeelname.title"]()}</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-4 px-0">
          {FIELDS.map((field, index) => {
            const labels = sportdeelnameFieldLabels(field, data);
            return (
              <Fragment key={field}>
                {index > 0 && <Separator />}
                <Field className="flex-row px-6">
                  <FieldTitle className="w-full max-w-[20ch]">
                    {sportdeelnameFieldTitle(field)}
                  </FieldTitle>
                  <div className="w-full max-w-70 min-w-0">
                    {INLINE_FIELDS.includes(field) ? (
                      <SportdeelnameFieldEditor field={field} data={data} />
                    ) : (
                      <SportdeelnameFieldCell
                        field={field}
                        data={data}
                        side="bottom"
                        triggerVariant="input"
                      >
                        {labels.length > 0 ? (
                          <span className="flex flex-wrap gap-2">
                            {labels.map((label) => (
                              <Badge key={label} variant="secondary" size="sm">
                                {label}
                              </Badge>
                            ))}
                          </span>
                        ) : (
                          <span className="text-muted-foreground text-sm">–</span>
                        )}
                      </SportdeelnameFieldCell>
                    )}
                  </div>
                </Field>
              </Fragment>
            );
          })}
        </CardContent>
      </Card>
    </div>
  );
}
